/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import {
  FilledButton,
  OutlinedButton,
  Spotlight,
  SpotlightTarget,
  TextButton,
  useNeedleTheme,
  useSpotlightContext,
} from '@neo4j-ndl/react';
import { useEffect } from 'react';

const Component = (props: { isChromatic: boolean }) => {
  const { themeClassName } = useNeedleTheme();
  const { setIsOpen, setActiveSpotlight } = useSpotlightContext();

  const targetId = `test-target-${themeClassName}`;

  useEffect(() => {
    if (props.isChromatic) {
      setActiveSpotlight(targetId);
      setIsOpen(true);
    }
  }, [setActiveSpotlight, setIsOpen, targetId, props.isChromatic]);

  return (
    <div className="n-flex n-justify-center n-gap-token-64">
      <FilledButton onClick={() => setActiveSpotlight(targetId)}>
        Activate Spotlight
      </FilledButton>
      <SpotlightTarget id={targetId} hasPulse={!props.isChromatic} asChild>
        <TextButton onClick={() => alert('Target button clicked')}>
          Target
        </TextButton>
      </SpotlightTarget>
      <Spotlight
        placement="bottom-end-top-end"
        target={targetId}
        actions={
          <OutlinedButton
            onClick={() => {
              setIsOpen(false);
              setActiveSpotlight(null);
            }}
          >
            Close
          </OutlinedButton>
        }
      >
        <Spotlight.Image
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjY2NjIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzMzMyIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkV4YW1wbGUgSW1hZ2U8L3RleHQ+PC9zdmc+"
          alt="example image"
        />
        <Spotlight.Header>This is a header</Spotlight.Header>
        <Spotlight.Body>This is content</Spotlight.Body>
      </Spotlight>
    </div>
  );
};

export default Component;
